import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

import {
  GRID_AREA_NAME,
  GRID_AREA_ARROW,
  GRID_AREA_GROUP,
} from 'layout/MainLayout/components/Sidebar/components/components/StudentSection/constants';
import { ReadonlyStateKey } from 'layout/MainLayout/components/Sidebar/components/components/StudentSection/types';
import { SidebarStateKey } from 'layout/MainLayout/components/Sidebar/store';
import {
  openedMixin,
  closedMixin,
} from 'layout/MainLayout/components/Sidebar/utils';

import type { StudentSectionReadonlyState } from 'layout/MainLayout/components/Sidebar/components/components/StudentSection/types';
import type { SidebarAnimatedComponentsState } from 'layout/MainLayout/components/Sidebar/types';

const interactiveGridTemplateArea = `
"${GRID_AREA_NAME} ${GRID_AREA_ARROW}"
"${GRID_AREA_GROUP} ${GRID_AREA_GROUP}"
`;

const defaultGridTemplateArea = `
"${GRID_AREA_NAME}"
"${GRID_AREA_GROUP}"
`;

const studentInfoHeight = 44;

export const ContentWrapper = styled(Box, {
  shouldForwardProp: prop =>
    prop !== SidebarStateKey.Opened && prop !== ReadonlyStateKey.Readonly,
})<SidebarAnimatedComponentsState & StudentSectionReadonlyState>(
  ({ theme, opened = false, readonly = false }) => ({
    width: 'fit-content',
    height: opened ? studentInfoHeight : 0,
    display: 'grid',
    gridTemplateAreas: readonly
      ? defaultGridTemplateArea
      : interactiveGridTemplateArea,
    opacity: opened ? 1 : 0,

    [theme.breakpoints.up('md')]: {
      ...(opened && {
        ...openedMixin({ theme }),
      }),
      ...(!opened && {
        ...closedMixin({ theme }),
      }),
    },
  }),
);
